import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { environment } from 'src/environments/environment';
import { ReportParametersResponse, ReportRequest, ReportResponse } from "../model/report-request";



@Injectable({
    providedIn: 'root'
})
export class ReportApiService {

    constructor(private httpClient: HttpClient) { }

    private baseUrl = `${environment.reportsApiUrl}`;

    getParams(restaurantId: string): Observable<ReportParametersResponse> {
        return this.httpClient.post<ReportParametersResponse>(`${this.baseUrl}/reports/overview/readReportParams`, { restaurantId }).pipe(
            map((res: any) => {
                return res;
            })
        );
    }

    getData(req: ReportRequest): Observable<ReportResponse> {
        return this.httpClient.post<ReportResponse>(`${this.baseUrl}/reports/overviewUpdated`, req).pipe(
            map((res: any) => {
                return res;
            })
        );
    }

    getDashboardUrl(restaurantId: string | null): Observable<string> {                             
        return this.httpClient.get(`${environment.supportApiUrl}/Pocket/GetReportsDashboardUrl?restId=${restaurantId}`).pipe(
            map((res: any) => {    
                if (res == null || res.embedUrl == null || res.embedUrl == "") throw("Error!");                
                
                console.log(res);        
                
                return res.embedUrl;
            })
        );
    }
}